import {useEffect, useMemo} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function PlateNotifications({ data }) {
    const allPlateNotificationsChart = useMemo(() => {
        const source = data?.notificationByPlate || [];

        return {
            totalItems: source.length,
            labels: source.map(item => item.text),
            values: source.map(item => Number(item.value || 0)),
        };
    }, [data]);

    const top10PlateNotification = useMemo(() => {
        const source = [...(data?.notificationByPlate || [])]
            .sort((a, b) => Number(b.value || 0) - Number(a.value || 0))
            .slice(0, 10);

        return {
            labels: source.map(item => item.text),
            values: source.map(item => Number(item.value || 0)),
        };
    }, [data]);

    const chartTitle = allPlateNotificationsChart.totalItems > 10 ? "Notificações por placa (TOP 10)" : "Notificações por placa";

    useEffect(() => {
        GraphicUtils.barChart(
            "plate-notifications",
            top10PlateNotification.values,
            top10PlateNotification.labels,
        );

        if (allPlateNotificationsChart.values.some(v => v > 0)) {
            ReportUtils.createExportableTable(
                allPlateNotificationsChart.labels,
                allPlateNotificationsChart.values,
                "Notificações por placa",
            );
        }
    }, [top10PlateNotification, allPlateNotificationsChart]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">{chartTitle}</span>
                <div id="plate-notifications" className="mt-3" />
            </div>
            <div className="chart-divisor" />
        </>
    )
}